import React from "react";
import {Input, Select, Button, Divider, Upload} from "antd";
import {UploadOutlined} from "@ant-design/icons";
import {FaPlus} from "react-icons/fa6";

const {TextArea} = Input;

export const CompanyApplication = () => {
    return (
        <>
            {/* Phần tiêu đề */}
            <div className="bg-blue-100 p-4 rounded-md mb-4">
                <h2 className="text-lg font-semibold text-blue-700">Hồ sơ công ty</h2>
                <p className="text-sm text-gray-700">
                    - Yêu cầu viết tiếng Việt có dấu, không viết chữ in hoa (trừ chữ cái đầu câu).
                    <br/>
                    - Các gian tuyển dụng không đúng quy định, không đạt chất lượng, nội dung không nghiêm túc sẽ bị xóa
                    không cần báo trước.
                </p>
            </div>

            {/* Form nhập thông tin */}
            <div className="space-y-4">
                <div>
                    <label className="block font-medium">
                        Tên công ty (Tên gian tuyển dụng) <span className="text-red-500">(*)</span>
                    </label>
                    <Input placeholder="Nhập tên công ty"/>
                </div>

                <div>
                    <label className="block font-medium">
                        Giới thiệu chung <span className="text-red-500">(*)</span>
                    </label>
                    <TextArea placeholder="Nhập giới thiệu chung về công ty" rows={4}/>
                </div>

                <div>
                    <label className="block font-medium">
                        Địa chỉ <span className="text-red-500">(*)</span>
                    </label>
                    <Input placeholder="Nhập địa chỉ công ty"/>
                </div>

                {/* Hàng chứa 4 dropdown */}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    <div className={"col-span-2 md:col-span-1"}>
                        <label className="block font-medium">
                            Quy mô <span className="text-red-500">(*)</span>
                        </label>
                        <Select placeholder="Chọn quy mô" className="w-full">
                            <Select.Option value="small">Dưới 50 người</Select.Option>
                            <Select.Option value="medium">50 - 200 người</Select.Option>
                            <Select.Option value="large">Trên 200 người</Select.Option>
                        </Select>
                    </div>
                    <div className={"col-span-2 md:col-span-1"}>
                        <label className="block font-medium">
                            Tỉnh thành <span className="text-red-500">(*)</span>
                        </label>
                        <Select placeholder="Chọn tỉnh thành" className="w-full">
                            <Select.Option value="hanoi">Hà Nội</Select.Option>
                            <Select.Option value="hochiminh">TP Hồ Chí Minh</Select.Option>
                            <Select.Option value="danang">Đà Nẵng</Select.Option>
                        </Select>
                    </div>
                    <div className={"col-span-2 md:col-span-1"}>
                        <label className="block font-medium">
                            Lĩnh vực <span className="text-red-500">(*)</span>
                        </label>
                        <Select placeholder="Chọn lĩnh vực" className="w-full">
                            <Select.Option value="it">Công nghệ thông tin</Select.Option>
                            <Select.Option value="marketing">Marketing</Select.Option>
                            <Select.Option value="finance">Tài chính</Select.Option>
                        </Select>
                    </div>
                    <div className={"col-span-2 md:col-span-1"}>
                        <label className="block font-medium">
                            Khu công nghiệp <span className="text-red-500">(*)</span>
                        </label>
                        <Select placeholder="Chọn khu công nghiệp" className="w-full">
                            <Select.Option value="bacninh">KCN Bắc Ninh</Select.Option>
                            <Select.Option value="binhduong">KCN Bình Dương</Select.Option>
                            <Select.Option value="longan">KCN Long An</Select.Option>
                        </Select>
                    </div>
                </div>

                {/* Hàng chứa 4 ô nhập dữ liệu */}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    <div className={"col-span-2 md:col-span-1"}>
                        <label className="block font-medium">
                            Mã số thuế <span className="text-red-500">(*)</span>
                        </label>
                        <Input placeholder="Nhập mã số thuế"/>
                    </div>
                    <div className={"col-span-2 md:col-span-1"}>
                        <label className="block font-medium">
                            Website
                        </label>
                        <Input placeholder="Nhập địa chỉ website"/>
                    </div>
                    <div className={"col-span-2 md:col-span-1"}>
                        <label className="block font-medium">
                            Số điện thoại <span className="text-red-500">(*)</span>
                        </label>
                        <Input placeholder="Nhập số điện thoại"/>
                    </div>
                    <div className={"col-span-2 md:col-span-1"}>
                        <label className="block font-medium">
                            Email <span className="text-red-500">(*)</span>
                        </label>
                        <Input placeholder="Nhập email"/>
                    </div>
                </div>
                <Divider/>
                <div className="col-span-2 mb-2.5">
                    <p className="font-semibold mb-1">Logo công ty</p>
                    <div className="flex flex-col md:flex-row gap-6">
                        <div className="w-full md:w-64 h-40 flex justify-center items-center border rounded-md border-gray-200">
                            <img className="h-36" src="https://vieclamsanxuat.com/img/icon_cpn.png" alt="logo" />
                        </div>
                        <div className="flex flex-col gap-2  ">
                            <Upload
                                listType="picture"
                            >
                                <Button type="primary" icon={<UploadOutlined />}>
                                    Upload
                                </Button>
                            </Upload>
                            <p>
                                Đăng hình dưới dạng tập tin PNG, JPG dung lượng không vượi quá 3MB</p>
                        </div>
                    </div>
                </div>
                <div className="col-span-2 mb-2.5">
                    <p className="font-semibold mb-1">Benner công ty (tối đa 3 files)</p>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4"  >
                        <div className="w-full h-40 flex items-center justify-center border border-gray-300 rounded-md">
                            <FaPlus className="w-10 h-10" />
                        </div>
                        <div className="h-40 flex items-center justify-center border border-gray-300 rounded-md">
                            <FaPlus className="w-10 h-10" />

                        </div>
                        <div className="h-40 flex items-center justify-center border border-gray-300 rounded-md">
                            <FaPlus className="w-10 h-10" />

                        </div>
                    </div>
                </div>
                <div className="col-span-2 mb-2.5">
                    <p className="font-semibold mb-1">Chọn địa chỉ trên bản đồ</p>
                    <div className="w-full flex gap-2">
                        <Input className="h-12 w-full  rounded-md" placeholder="Dán kinh độ vĩ độ vào đây..." />
                        <Button className="h-12 w-24 text-lg font-semibold" type="primary">Lấy vị trí</Button>

                    </div>
                </div>
                <Divider/>
                {/* Nút gửi */}
                <div className={"justify-between flex items-center"}>
                    <p className="text-sm text-red-500">(*) Bắt buộc</p>
                    <Button className={"h-fit w-24 text-lg font-semibold"} type={"primary"}>Tạo mới</Button>
                </div>
            </div>
        </>
    );
};
